export default __webpack_public_path__ + "static/media/about_us_retail.bf51821f.png";